import Signup from '@/models/Signup'
import { auth as backend } from '@/api'

export default {

  namespaced: true,

  state: {
    signup: new Signup
  },

  mutations: {
    full_name: (state, payload) => state.signup.full_name = payload,
    email: (state, payload) => state.signup.email = payload,
    company: (state, payload) => state.signup.company = payload,
    password: (state, payload) => state.signup.password = payload,
    password_confirmation: (state, payload) => state.signup.password_confirmation = payload,
  },

  actions: {
    handle: ({state}) => new Promise((resolve, reject) => {
      backend.signup(state.signup, response => {
        resolve(response.data)
      }, error => {
        reject(error)
      })
    })
  },

  getters: {
    signup: state => state.signup
  }

}